<template>
  <div class="client-quotation">
    <!-- <b-tabs pills card>
                <b-tab title="Booking Request" active
                    ><b-card-text> -->

    <SelectType v-model="request_quotation.service_type" />
    <!-- v-if="request_quotation.service_type" -->
    <!-- :is="checkServiceReturnComponent(request_quotation.service_type)" -->
    <VanTruckSale
      :is="checkServiceReturnComponent(6)"
      :value.sync="value"
      ref="NewVanTruckSale"
      :readonly="readonly"
      :key="reload"
    />
    <!-- </b-card-text
                ></b-tab>

                <b-tab disabled title="Quote"
                    ><b-card-text>Tab contents 2</b-card-text></b-tab
                >
            </b-tabs> -->
  </div>
</template>

<script>
import SelectType from "./components/SelectType.vue";
import { $ctx } from "@themeConfig";
import moment from "moment";
import VanTruckSale from "./VanTruckSale.vue";
import { ValidationObserver } from "vee-validate";
export default {
  props: {
    view_RequestQuotation: { default: null },
    readonly: false,
    value: {
      type: Object,
      default: function () {
        return {
          showAddMore: [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: {
                    lenght: null,
                    width: null,
                    height: null,
                  },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ],

          valueVan: [
            {
              id: 1,
              hasDelete: false,
              truck_type: null,
              commodity_type: null,
              quantity: null,
              VanLine: [
                {
                  id: 2,
                  hasDelete: false,
                  commodity: null,
                  total_gross_weight: null,
                  total_package: null,
                  total_volume: null,
                  dimension: {
                    length: null,
                    width: null,
                    height: null,
                  },
                },
              ],
            },
          ],

          valueContainer: [
            {
              id: 1,
              hasDelete: false,
              commodity_type: null,
              commodity: null,
              container_type: null,
                  quantity: null,
                  total_gross_weight: null,
       
            },
          ],

          paymentTerms: null,
          pickUpContact: {
            name: null,
            phone: null,
          },
          deliveryContact: {
            name: null,
            phone: null,
          },
          isPickUpInput: null,
          eta: null,
          quotation: null,
          etd: null,
          customs_other_service_type: null,
          has_container_trucking: null,
          isHideShows: false,
          isHideShowPks: false,
          other_pickup_location: null,
          other_delivery_location: null,
          pickup_location: null,
          delivery_location: null,
          other_pickup_region: null,
          other_delivery_region: null,
          pickup_region: null,
          delivery_region: null,
          company_id: null,
          customer_id: null,
          service_type: null,
          pod_port: null,
          pol_port: null,
          incoterms: null,
          cont_type: null,
          goods_type: null,
          package_type: null,
          transport_type: null,
          deport: null,
          business_type: null,
          so_luong: null,
          trong_luong: null,
          mo_ta: null,
          volume: null,
          from_date: null,
          to_date: null,
          other_service: null,
          notes: null,
          so_khoi: null,
          so_kien: null,
          shipping_line: null,
          place_of_stuffing: null,
          totalChargeWeight: null,
          size_: {
            length_: null,
            width_: null,
            height_: null,
          },
          cargo_ready: moment().format("DD/MM/YY HH:mm"),
          customs_addr: null,
          hs_code: null,
          //Container Truck
          pickUpDateTime: null,
          pickUpDate: null,
          pickUpTime: null,
          deliveryDateTime: null,
          deliveryDate: null,
          deliveryTime: null,
          cargo_booking: null,
          carrier: null,
          cargo_closing_dateTime: null,
          cargo_closing_date: null,
          cargo_closing_time: null,
          cargo_details_commodity_truck: [
            {
              id: 1,
              hasDelete: false,
              commodity_type: null,
              commodity: null,
            },
          ],
          cargo_details_container_truck: [
            {
              id: 2,
              hasDelete: false,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          additional_custom: false,
          additional_custom_input: null,
          has_other_custom: false,
          place_of_custom: null,
          HS_code_truck: null,
          customs_type: null,
          notes_truck: null,
          door_contact_pick_up: {
            name: "",
            phone: "",
            email: "",
          },
          door_contact_delivery: {
            name: "",
            phone: "",
            email: "",
          },
          inland_contact_pick_up: {
            name: "",
            phone: "",
            email: "",
          },
          inland_contact_delivery: {
            name: "",
            phone: "",
            email: "",
          },
        };
      },
    },
  },
  components: {
    SelectType,
    VanTruckSale,
    ValidationObserver,
  },

  data() {
    return {
      reload: 23,
      modalSchedule: false,
      buttonKey: 1,
      moment,
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      vm: this,
      userData: JSON.parse(localStorage.getItem("userData")),

      locationsByUser: [],

      request_quotation: {
        quotation: null,
        shippingType: null,
        eta: null,
        etd: null,
        customs_other_service_type: null,
        has_container_trucking: null,
        isHideShows: false,
        isHideShowPks: false,
        other_delivery_location: null,
        pickup_location: null,
        delivery_location: null,
        other_pickup_region: null,
        other_delivery_region: null,
        pickup_region: null,
        delivery_region: null,
        company_id: null,
        customer_id: null,
        service_type: "6",
        pod_port: null,
        pol_port: null,
        incoterms: null,
        cont_type: null,
        goods_type: null,
        package_type: null,
        transport_type: null,
        deport: null,
        business_type: null,
        so_luong: null,
        trong_luong: null,
        mo_ta: null,
        volume: null,
        from_date: null,
        to_date: null,
        other_service: null,
        notes: null,
        so_khoi: null,
        so_kien: null,
        shipping_line: null,
        place_of_stuffing: null,
        totalChargeWeight: null,
        size_: {
          length_: null,
          width_: null,
          height_: null,
        },
        cargo_ready: moment().format("DD/MM/YY HH:mm"),
        customs_addr: null,
        hs_code: null,
        isPickUpInput: false,
        isAddressInput: false,
        valuePickupInput: null,
        valueAddressInput: null,
        pickUpContact: {
          name: null,
          phone: null,
        },
        deliveryContact: {
          name: null,
          phone: null,
        },
        pickUpDateTime: null,
        pickUpDate: null,
        pickUpTime: null,
        deliveryDateTime: null,
        deliveryDate: null,
        deliveryTime: null,
        cargo_booking: null,
        carrier: null,
        cargo_closing_dateTime: null,
        cargo_closing_date: null,
        cargo_closing_time: null,
        cargo_details_commodity_truck: [
          {
            id: 1,
            hasDelete: false,
            cont_type: null,
            quantity: null,
          },
        ],
        cargo_details_container_truck: [
          {
            id: 2,
            hasDelete: false,
            commodity_type: null,
            commodity: null,
            total_gross_weight: null,
            total_package: null,
            total_volume: null,
          },
        ],
        additional_custom: false,
        additional_custom_input: null,
        has_other_custom: false,
        place_of_custom: null,
        HS_code_truck: null,
        customs_type: null,
        notes_truck: null,
      },
      customer_list_options: null,

      volumes: [
        { id: 1, text: "1-10" },
        { id: 2, text: "10-30" },
        { id: 3, text: "30-50" },
        { id: 4, text: "50-100" },
        { id: 5, text: ">100" },
      ],
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      customer_list: null,
      useName: null,
      costs: [],

      countRq: 0,
    };
  },
  created() {
    if (this.view_RequestQuotation != null) {
      // this.request_quotation = this.view_RequestQuotation;
      this.value = this.view_RequestQuotation;
      this.reload++;
      this.request_quotation.bookingID = this.view_RequestQuotation.id;
      this.request_quotation.sale_name = this.view_RequestQuotation.sale_name;
      this.request_quotation.customer_name =
        this.view_RequestQuotation.customer_name;

      this.request_quotation.customer_id =
        this.view_RequestQuotation.customer_id;
      this.request_quotation.customer_phone =
        this.view_RequestQuotation.customer_phone;
      this.request_quotation.customer_email =
        this.view_RequestQuotation.customer_email;
      this.request_quotation.customer_company_name =
        this.view_RequestQuotation.customer_company_name;
      this.view_RequestQuotation.customer_company_name;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_location != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_location != null
          ? true
          : false;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_region != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_region != null ? true : false;
      !this.request_quotation.size_
        ? (this.request_quotation = {
            ...this.request_quotation,
            size_: {
              length_: null,
              width_: null,
              height_: null,
            },
          })
        : "";
    }
  },
  mounted() {
    this.$root.$on("bv::modal::shown", (bvEvent, modalId) => {
      document.getElementsByClassName("modal-content").forEach(function (v) {
        v.removeAttribute("tabindex");
      });
    });

    if (this.booking) {
      this.costs = this.booking.costs;
    }
    if (this.createdRequestQuotation) {
      this.request_quotation = this.createdRequestQuotation;
    }
  },
  methods: {
    checkServiceReturnComponent(type) {
      if (type && type == 6) {
        return "VanTruckSale";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/customs/request-quotation.scss";
@import "@core/scss/customs/inputV2.scss";
</style>
